import { Controller } from '@hotwired/stimulus';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

/**
 * Hydrates saved post HTML: div.post-content-carousel[data-controller="post-carousel"].
 */
export default class extends Controller {
  connect() {
    this.prevBtn = this.element.querySelector('[data-carousel-prev]');
    this.nextBtn = this.element.querySelector('[data-carousel-next]');
    this.track = this.element.querySelector('.post-content-carousel__track');
    this.slides = this.element.querySelectorAll('.post-content-carousel__slide');
    this.counterCurrent = this.element.querySelector('[data-carousel-counter-current]');
    this.counterTotal = this.element.querySelector('[data-carousel-counter-total]');
    this.captions = this.element.querySelectorAll('[data-carousel-caption]');

    if (this.counterTotal) this.counterTotal.textContent = String(this.slides.length || 0);

    if (!this.track || this.slides.length <= 1) {
      // Keep counters correct and ensure any inactive videos are paused
      this._setCounter(0);
      this._pauseInactiveVideos();
      this._updateCaption(0);
      return;
    }

    this.swiper = new Swiper(this.track, {
      modules: [Navigation],
      slidesPerView: 1,
      loop: this.slides.length > 1,
      // Keep our existing nav buttons and styles
      navigation: {
        prevEl: this.prevBtn,
        nextEl: this.nextBtn,
      },
      on: {
        init: () => {
          this._setCounter(this.swiper?.realIndex ?? 0);
          this._pauseInactiveVideos();
          this._updateCaption(this.swiper?.realIndex ?? 0);
        },
        slideChange: () => {
          this._setCounter(this.swiper?.realIndex ?? 0);
          this._pauseInactiveVideos();
          this._updateCaption(this.swiper?.realIndex ?? 0);
        },
      },
    });
  }

  disconnect() {
    try {
      this.swiper?.destroy?.(true, true);
    } catch (e) {}
    this.swiper = null;
  }

  _setCounter(i) {
    if (this.counterCurrent) this.counterCurrent.textContent = String((i ?? 0) + 1);
    if (this.counterTotal) this.counterTotal.textContent = String(this.slides.length || 0);
  }

  _updateCaption(i) {
    const idx = i ?? 0;
    this.captions.forEach((caption, index) => {
      caption.style.display = index === idx ? '' : 'none';
    });
  }

  // show(i) {
  //   this.slides.forEach((el, idx) => {
  //     const isActive = idx === i;
  //     el.style.removeProperty('display');
  //     el.classList.toggle('post-content-carousel__slide--hidden', !isActive);
  //     el.classList.toggle('post-content-carousel__slide--active', isActive);
  //     if (idx !== i) {
  //       const video = el.querySelector?.('video');
  //       if (video && !video.paused) {
  //         try { video.pause(); } catch (e) {}
  //       }
  //     }
  //   });
  // }

  _pauseInactiveVideos() {
    const active = this.element.querySelector('.post-content-carousel__slide.swiper-slide-active');
    this.element.querySelectorAll('.post-content-carousel__slide video').forEach((video) => {
      if (active && active.contains(video)) return;
      if (video && !video.paused) {
        try { video.pause(); } catch (e) {}
      }
    });
  }
}
